import { z } from "zod";

import { fetchWithThrow } from "@rosette/web_utils/src/fetchWithThrow.js";


export const GrantAllAchievementsRequest = z.object({
    userPublicID: z.string(),
});
export type GrantAllAchievementsRequest = z.infer<typeof GrantAllAchievementsRequest>;


export const GrantAllAchievementsResponse = z.object({
    success: z.boolean(),
});
export type GrantAllAchievementsResponse = z.infer<typeof GrantAllAchievementsResponse>;


export async function grantAllAchievements(userPublicID: string): Promise<void> {
    const request: GrantAllAchievementsRequest = {
        userPublicID,
    };
    const response = await fetchWithThrow("/api/admin/grantAllAchievements", {
        method: "POST",
        credentials: "include",
        headers: {
            "Accept": "application/json",
            "Content-Type": "application/json",
        },
        body: JSON.stringify(request),
    });
    GrantAllAchievementsResponse.parse(await response.json());
}
